import { useContext, useEffect } from "react";
import State from "../../../../../../context";
import Cookies from "js-cookie";
import { Flex } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalClientPersonalInfo from "./components/SectionDetailsClient/ModalClientPersonalInfo";
import ModalCompanyUserSettings from "../../../super_admin/component/ModalCompanyUserSettings";
import ModalArchiveUser from "../../../../../../molecule/ModalArchiveUser";
import ModalViewFolders from "../../../super_admin/page/PageUsers/component/SectionUserPermission/component/ModalViewFolders";
import SectionDetailsAdvisor from "./components/SectionDetailsAdvisor";
import SectionDetailsClient from "./components/SectionDetailsClient";
import SectionHome from "./components/SectionHome";
import SectionUserPermission from "../../../super_admin/page/PageUsers/component/SectionUserPermission";

import StyledContainer from "./style";

import {
  addWealthAdvisor,
  archiveWealthManager,
  impersonateUser,
  getWealthAdvisorData,
  updateWealthAdvisor,
} from "../../request";
import {
  isTypeAffiliateAdvisor,
  isTypeLevelWealthAdvisor,
  isTypeLevelWealthEnterpriseAdmin,
  isTypeLevelWealthEnterpriseAdminAdvisor,
  isTypeProPortalAdvisor,
  isTypeProPortalAffiliateAdvisor,
} from "../../../super_admin/helper";
import { isWindowReadonly } from "../../../advisor/helper";
import { getAllManagedUsersOfAdvisors } from "../../../../../../utils/helper/specialized";
import {
  archiveLead,
  openProposal,
  updateManagedUser,
} from "../../../../../../utils/request/manager";
import {
  getCompanyUsersByJwt,
  getUserTypes,
} from "../../../super_admin/request";
import { isPermissionReadonly } from "../../../super_admin/helper";
import { updateCompanyUserByWealthAdmin } from "../../request";

import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const PagePeople = () => {
  const [state] = useContext(State);

  const activeClientData = state.companyUsersList?.find(
    it => it.email === state.activeEmail
  );

  useEffect(() => {
    if (!state.companyUsersList) {
      state.setKeyValue("loading", true);

      getCompanyUsersByJwt()
        .then(data => state.setKeyValue("companyUsersList", data))
        .catch(state.showError)
        .finally(() => state.setKeyValue("loading", false));
    }

    if (!state.userTypes) {
      getUserTypes()
        .then(data => state.setKeyValue("userTypes", data))
        .catch(state.showError);
    }
  }, []);

  const getActiveAdvisorData = () =>
    getWealthAdvisorData({
      clientEmail: state.activeEmail,
      userEmail: state._id,
    }).catch(state.showError);

  const handleActionAdvisorEdit = email => {
    state.setKeyValue("activeEmail", email);
    state.setKeyValue("openModalCompanyUserSettings", true);
  };

  const handleActionAdvisorTransfer = email => {
    console.log(email);
  };

  const handleActionClientArchive = email => {
    state.setKeyValue("activeEmail", email);
    state.setKeyValue("openModalArchiveClient", true);
  };

  const handleActionClientTransfer = email => {
    console.log(email);
  };

  const handleActionManagerArchive = email => {
    state.setKeyValue("activeEmail", email);
    state.setKeyValue("openModalArchiveManager", true);
  };

  const handleButtonNewAdvisor = () => {
    state.setKeyValue("activeEmail", null);
    state.setKeyValue("openModalCompanyUserSettings", true);
  };

  const handleEditActiveClient = () => {
    state.setKeyValue("openModalCompanyUserSettings", true);
  };

  const onClickProposalOpen = (clientEmail, advisorEmail) => {
    openProposal({
      advisorEmail,
      clientEmail,
      managerEmail: state._id,
    });
  };

  const handleViewFolders = () => {
    state.setKeyValue("openModalViewFolders", true);
  };

  const handleOpenManagedUser = email => {
    impersonateUser({
      clientEmail: email,
      userEmail: state._id,
    })
      .then(response => {
        Cookies.set(`jwt__${email.toLowerCase()}`, response.jwt, {
          expires: 0.5, // half a day (12 hours)
          secure: true,
        });

        const userType = response.subscription.userType;

        if (
          isTypeLevelWealthEnterpriseAdmin(userType) ||
          isTypeLevelWealthEnterpriseAdminAdvisor(userType)
        ) {
          window.open(
            `/wealth-admin-portal/dashboard?email=${encodeURIComponent(email)}`,
            isPermissionReadonly(state.permissions?.manageEnterpriseAdmins)
              ? "windowReadonly"
              : ""
          );
        } else if (
          isTypeAffiliateAdvisor(userType) ||
          isTypeLevelWealthAdvisor(userType) ||
          isTypeProPortalAdvisor(userType) ||
          isTypeProPortalAffiliateAdvisor(userType)
        ) {
          window.open(
            `/wealth-advisor-portal/leads?email=${encodeURIComponent(email)}`,
            isPermissionReadonly(state.permissions?.manageAdvisors)
              ? "windowReadonly"
              : ""
          );
        }
      })
      .catch(state.showError);
  };

  const handleUserNameClick = ({ activeEmail, activeSection }) => {
    state.setKeyValue("activeEmail", activeEmail);
    state.setKeyValue("activeSection", activeSection);
  };

  const onClickEditInfo = editClientInfoViewType => {
    state.setKeyValue("editClientInfoViewType", editClientInfoViewType);
    state.setKeyValue("openModalClientPersonalInfo", true);
  };

  const submitAdvisorSettings = values => {
    state.setKeyValue("loading", true);

    const requestBody = {
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
      phone: values.phone ? values.phoneNumber + "" : undefined,
      phoneAlt: values.phoneAlt ? values.phoneAlt + "" : undefined,
      type: values.type,
    };

    const requestFeature = state.activeEmail
      ? updateWealthAdvisor
      : addWealthAdvisor;

    requestFeature({
      requestBody,
      userEmail: state._id,
    })
      .then(() =>
        getCompanyUsersByJwt()
          .then(data => {
            state.setKeyValue("companyUsersList", data);
            state.showSuccess(
              state.activeEmail
                ? "User data updated"
                : "User added successfully"
            );
            state.setKeyValue("openModalCompanyUserSettings", false);
          })
          .finally(() => state.setKeyValue("loading", false))
      )
      .catch(error => {
        state.showError(error);
        state.setKeyValue("loading", false);
      });
  };

  const submitClientArchive = () => {
    state.setKeyValue("loading", true);

    archiveLead({
      email: state.activeEmail,
      userManagerEmail: getAllManagedUsersOfAdvisors(
        state.managedUserManagers
      )?.find(it => it.email === state.activeEmail)?.advisorEmail,
    })
      .then(response => {
        state.setUserData().then(() => {
          state.showSuccess(response.data);
          state.setKeyValue("openModalArchiveClient", false);
          state.setKeyValue("activeEmail", null);
        });
      })
      .catch(error => {
        state.setKeyValue("loading", false);
        state.showError(error);
      });
  };

  const submitClientPersonalInfo = values => {
    state.setKeyValue("loading", true);

    updateManagedUser({
      managerEmail: state._id,
      requestPayload: values,
    })
      .then(() =>
        state
          .setUserData()
          .then(() => {
            values.email && state.setKeyValue("activeEmail", values.email);
            state.setKeyValue("openModalClientPersonalInfo", false);
            state.showSuccess("Personal data updated");
          })
          .catch(state.showError)
          .finally(() => state.setKeyValue("loading", false))
      )
      .catch(error => {
        state.showError(error);
        state.setKeyValue("loading", false);
      });
  };

  const submitManagerArchive = () => {
    state.setKeyValue("loading", true);

    archiveWealthManager({
      clientEmail: state.activeEmail,
      userEmail: state._id,
    })
      .then(() => {
        getCompanyUsersByJwt()
          .then(data => {
            state.setKeyValue("companyUsersList", data);
            state.setKeyValue("activeEmail", null);
            state.setKeyValue("openModalArchiveManager", false);
            state.showSuccess("User archived successfully");
          })
          .catch(state.showError)
          .finally(() => state.setKeyValue("loading", false));
      })
      .catch(error => {
        state.setKeyValue("loading", false);
        state.showError(error);
      });
  };

  const submitPermissions = updatedPermissions => {
    state.setKeyValue("loading", true);

    const requestPayload = {
      email: activeClientData.email,
      firstName: activeClientData.firstName,
      lastName: activeClientData.lastName,
      permissions: {
        ...activeClientData.permissions,
        ...updatedPermissions,
      },
      phone: activeClientData.phone ?? "",
      phoneAlt: activeClientData.phoneAlt ?? "",
      type: activeClientData.type,
    };

    updateCompanyUserByWealthAdmin({
      companyUserEmail: activeClientData.email,
      requestPayload,
      userEmail: state._id,
    })
      .then(() =>
        getCompanyUsersByJwt()
          .then(data => {
            state.setKeyValue("listUsers", data);
            state.showSuccess("User updated!");
          })
          .catch(state.showError)
          .finally(() => state.setKeyValue("loading", false))
      )
      .catch(error => {
        state.showError(error);
        state.setKeyValue("loading", false);
      });
  };

  return (
    <StyledContainer>
      {state.activeSection === "admin" && (
        <SectionUserPermission
          disableEdit={isPermissionReadonly(
            state.permissions?.manageEnterpriseAdmins
          )}
          handleEditActiveClient={handleEditActiveClient}
          handleViewFolders={handleViewFolders}
          itemsBreadcrumb={[
            {
              onClick: () => {
                state.setKeyValue("activeTabSectionOneCompany", "users");
                state.setKeyValue("activeSection", "companyOne");
              },
              title: (
                <Flex align="center" gap={8} style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    style={{ fontSize: 14 }}
                  />
                  <b>All Users</b>
                </Flex>
              ),
            },
            {
              title: <span>User Profile</span>,
            },
          ]}
          loading={state.loading}
          submitPermissions={submitPermissions}
          userData={activeClientData}
          userTypes={state.userTypes}
        />
      )}

      {state.activeSection === "advisor" && (
        <SectionDetailsAdvisor
          disableEdit={
            isWindowReadonly() ||
            isPermissionReadonly(state.permissions?.manageAdvisors)
          }
          getUserData={getActiveAdvisorData}
          handleActionClientArchive={handleActionClientArchive}
          handleActionClientTransfer={handleActionClientTransfer}
          handleBreadcrumbClick={() =>
            state.setKeyValue("activeSection", "home")
          }
          handleEditActiveClient={handleEditActiveClient}
          handleOpenManagedUser={handleOpenManagedUser}
          handleProposalView={onClickProposalOpen}
          handleUserNameClick={handleUserNameClick}
          handleViewFolders={handleViewFolders}
          submitPermissions={submitPermissions}
        />
      )}

      {state.activeSection === "client" && (
        <SectionDetailsClient
          clientData={getAllManagedUsersOfAdvisors(
            state.managedUserManagers
          )?.find(it => it.email === state.activeEmail)}
          disableEdit={isPermissionReadonly(state.permissions?.accessLevel)}
          onClickProposalOpen={onClickProposalOpen}
          itemsBreadcrumb={[
            {
              onClick: () => {
                state.setKeyValue(
                  "activeEmail",
                  getAllManagedUsersOfAdvisors(state.managedUserManagers)?.find(
                    it => it.email === state.activeEmail
                  )?.advisorEmail
                );
                state.setKeyValue("activeSection", "home");
              },
              title: (
                <Flex align="center" gap={8} style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    style={{ fontSize: 14 }}
                  />
                  <b>All Users</b>
                </Flex>
              ),
            },
            {
              title: <span>User Profile</span>,
            },
          ]}
          managerEmail={state._id}
          onClickEditInfo={onClickEditInfo}
          organization={state.organization?.name}
          productsList={state.productsList}
        />
      )}

      {state.activeSection !== "admin" &&
        state.activeSection !== "advisor" &&
        state.activeSection !== "client" && (
          <SectionHome
            defaultActiveKey={state.activeTabPagePeople}
            handleActionAdvisorEdit={handleActionAdvisorEdit}
            handleActionAdvisorTransfer={handleActionAdvisorTransfer}
            handleActionClientArchive={handleActionClientArchive}
            handleActionClientTransfer={handleActionClientTransfer}
            handleActionManagerArchive={handleActionManagerArchive}
            handleButtonNewAdvisor={handleButtonNewAdvisor}
            handleOpenManagedUser={handleOpenManagedUser}
            handleProposalView={onClickProposalOpen}
            handleUserNameClick={handleUserNameClick}
            isDisabledAdvisorResetPassword={isPermissionReadonly(
              state.permissions?.resetAdvisorPasswords
            )}
            listCompanyUsers={state.companyUsersList}
            listManagers={state.managedUserManagers}
            loading={state.loading}
            onTabChange={activeTab =>
              state.setKeyValue("activeTabPagePeople", activeTab)
            }
            permissions={state.permissions}
          />
        )}

      <ModalArchiveUser
        clientData={getAllManagedUsersOfAdvisors(
          state.managedUserManagers
        )?.find(it => it.email === state.activeEmail)}
        loading={state.loading}
        onCancel={() => state.setKeyValue("openModalArchiveClient", false)}
        onSuccess={submitClientArchive}
        open={state.openModalArchiveClient}
      />
      <ModalArchiveUser
        clientData={state.companyUsersList?.find(
          it => it.email === state.activeEmail
        )}
        loading={state.loading}
        onCancel={() => state.setKeyValue("openModalArchiveManager", false)}
        onSuccess={submitManagerArchive}
        open={state.openModalArchiveManager}
      />
      <ModalClientPersonalInfo
        clientData={getAllManagedUsersOfAdvisors(
          state.managedUserManagers
        )?.find(it => it.email === state.activeEmail)}
        loading={state.loading}
        onCancel={() => state.setKeyValue("openModalClientPersonalInfo", false)}
        onFinish={submitClientPersonalInfo}
        open={state.openModalClientPersonalInfo}
        viewType={state.editClientInfoViewType}
      />
      <ModalCompanyUserSettings
        companyName={state.organization?.name}
        companyType={state.subscription?.userType}
        loading={state.loading}
        onCancel={() =>
          state.setKeyValue("openModalCompanyUserSettings", false)
        }
        onFinish={submitAdvisorSettings}
        open={state.openModalCompanyUserSettings}
        userData={getAllManagedUsersOfAdvisors(state.managedUserManagers)?.find(
          it => it.email === state.activeEmail
        )}
        userTypes={state.userTypes?.filter(it => !it.type.includes("Admin"))}
      />
      <ModalViewFolders
        onCancel={() => state.setKeyValue("openModalViewFolders", false)}
        open={state.openModalViewFolders}
      />
    </StyledContainer>
  );
};

export default PagePeople;
